/* tslint:disable */
/* eslint-disable */
/* @relayHash 77aeb5f12fef3865f0a855fbf19ea9a9 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MODERATOR" | "STAFF" | "UNANSWERED" | "%future added value";
export type CreateCommentReplyInput = {
    nudge?: boolean | null;
    storyID: string;
    parentID: string;
    parentRevisionID: string;
    body: string;
    clientMutationId: string;
    media?: CreateCommentMediaInput | null;
};
export type CreateCommentMediaInput = {
    type: string;
    id?: string | null;
    url: string;
    width?: string | null;
    height?: string | null;
};
export type CreateCommentReplyMutationVariables = {
    input: CreateCommentReplyInput;
};
export type CreateCommentReplyMutationResponse = {
    readonly createCommentReply: {
        readonly edge: {
            readonly cursor: unknown;
            readonly node: {
                readonly id: string;
                readonly status: COMMENT_STATUS;
                readonly story: {
                    readonly settings: {
                        readonly live: {
                            readonly enabled: boolean;
                        };
                    };
                };
                readonly parent: {
                    readonly id: string;
                    readonly tags: ReadonlyArray<{
                        readonly code: TAG;
                    }>;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment">;
            };
        };
        readonly clientMutationId: string;
    };
};
export type CreateCommentReplyMutation = {
    readonly response: CreateCommentReplyMutationResponse;
    readonly variables: CreateCommentReplyMutationVariables;
};



/*
mutation CreateCommentReplyMutation(
  $input: CreateCommentReplyInput!
) {
  createCommentReply(input: $input) {
    edge {
      cursor
      node {
        id
        ...CommentContainer_comment
        ...ReplyListContainer1_comment
        ...IgnoredTombstoneOrHideContainer_comment
        status
        story {
          settings {
            live {
              enabled
            }
          }
          id
        }
        parent {
          id
          tags {
            code
          }
        }
      }
    }
    clientMutationId
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  ...ReplyCommentFormContainer_comment
  ...EditCommentFormContainer_comment
  ...ReactionButtonContainer_comment
  ...ReportFlowContainer_comment
  ...ReportButton_comment
  ...CaretContainer_comment
  ...RejectedTombstoneContainer_comment
  ...UserTagsContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UsernameContainer_comment
  ...MediaSectionContainer_comment
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...LocalReplyListContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "concreteType": "StorySettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "LiveConfiguration",
                "kind": "LinkedField",
                "name": "live",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v8 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            (v9 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v18 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v19 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            (v20 /*: any*/),
                            (v21 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v19 /*: any*/),
                            (v20 /*: any*/)
                        ],
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v21 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v19 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v23 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 10
        } as any),
        ({
            "kind": "Literal",
            "name": "orderBy",
            "value": "CREATED_AT_ASC"
        } as any)
    ], v24 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "localReplies",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            (v10 /*: any*/),
            (v24 /*: any*/),
            (v12 /*: any*/),
            (v9 /*: any*/),
            (v4 /*: any*/),
            (v13 /*: any*/),
            (v6 /*: any*/),
            (v26 /*: any*/),
            (v27 /*: any*/),
            (v14 /*: any*/),
            (v15 /*: any*/),
            (v16 /*: any*/),
            (v17 /*: any*/),
            (v22 /*: any*/)
        ],
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v3 /*: any*/),
                    (v25 /*: any*/),
                    (v29 /*: any*/),
                    (v10 /*: any*/),
                    (v24 /*: any*/),
                    (v12 /*: any*/),
                    (v9 /*: any*/),
                    (v4 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v26 /*: any*/),
                    (v27 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v22 /*: any*/),
                    (v28 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v32 = ({
        "alias": null,
        "args": (v23 /*: any*/),
        "filters": [
            "orderBy"
        ],
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v33 = ({
        "kind": "ClientExtension",
        "selections": [
            (v26 /*: any*/),
            (v27 /*: any*/),
            (v29 /*: any*/)
        ]
    } as any), v34 = ({
        "alias": null,
        "args": (v23 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v31 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            (v25 /*: any*/),
                            (v29 /*: any*/),
                            (v10 /*: any*/),
                            (v24 /*: any*/),
                            (v12 /*: any*/),
                            (v9 /*: any*/),
                            (v4 /*: any*/),
                            (v13 /*: any*/),
                            (v6 /*: any*/),
                            (v26 /*: any*/),
                            (v27 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/),
                            (v22 /*: any*/),
                            (v28 /*: any*/),
                            (v18 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            (v30 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v2 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v3 /*: any*/),
                    (v29 /*: any*/),
                    (v10 /*: any*/),
                    (v24 /*: any*/),
                    (v12 /*: any*/),
                    (v9 /*: any*/),
                    (v4 /*: any*/),
                    (v13 /*: any*/),
                    (v6 /*: any*/),
                    (v26 /*: any*/),
                    (v27 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v22 /*: any*/),
                    (v34 /*: any*/),
                    (v32 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateCommentReplyMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateCommentReplyPayload",
                    "kind": "LinkedField",
                    "name": "createCommentReply",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edge",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CommentContainer_comment"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ReplyListContainer1_comment"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "IgnoredTombstoneOrHideContainer_comment"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateCommentReplyMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateCommentReplyPayload",
                    "kind": "LinkedField",
                    "name": "createCommentReply",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edge",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v3 /*: any*/),
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v12 /*: any*/),
                                        (v9 /*: any*/),
                                        (v4 /*: any*/),
                                        (v13 /*: any*/),
                                        (v6 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        (v22 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v23 /*: any*/),
                                            "concreteType": "CommentsConnection",
                                            "kind": "LinkedField",
                                            "name": "replies",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v24 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v15 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v22 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": (v23 /*: any*/),
                                                                    "concreteType": "CommentsConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "replies",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CommentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v3 /*: any*/),
                                                                                        (v10 /*: any*/),
                                                                                        (v24 /*: any*/),
                                                                                        (v12 /*: any*/),
                                                                                        (v9 /*: any*/),
                                                                                        (v4 /*: any*/),
                                                                                        (v13 /*: any*/),
                                                                                        (v6 /*: any*/),
                                                                                        (v14 /*: any*/),
                                                                                        (v15 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        (v17 /*: any*/),
                                                                                        (v22 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": (v23 /*: any*/),
                                                                                            "concreteType": "CommentsConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "replies",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "CommentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Comment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v3 /*: any*/),
                                                                                                                (v25 /*: any*/),
                                                                                                                (v10 /*: any*/),
                                                                                                                (v24 /*: any*/),
                                                                                                                (v12 /*: any*/),
                                                                                                                (v9 /*: any*/),
                                                                                                                (v4 /*: any*/),
                                                                                                                (v13 /*: any*/),
                                                                                                                (v6 /*: any*/),
                                                                                                                (v14 /*: any*/),
                                                                                                                (v15 /*: any*/),
                                                                                                                (v16 /*: any*/),
                                                                                                                (v17 /*: any*/),
                                                                                                                (v22 /*: any*/),
                                                                                                                (v18 /*: any*/),
                                                                                                                {
                                                                                                                    "kind": "ClientExtension",
                                                                                                                    "selections": [
                                                                                                                        (v26 /*: any*/),
                                                                                                                        (v27 /*: any*/),
                                                                                                                        (v28 /*: any*/),
                                                                                                                        (v29 /*: any*/)
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v2 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v30 /*: any*/),
                                                                                                {
                                                                                                    "kind": "ClientExtension",
                                                                                                    "selections": [
                                                                                                        (v31 /*: any*/)
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                        },
                                                                                        (v32 /*: any*/),
                                                                                        (v18 /*: any*/),
                                                                                        (v33 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v30 /*: any*/),
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                (v35 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                },
                                                                (v32 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v33 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v30 /*: any*/),
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "viewNewEdges",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v29 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v23 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v35 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v3 /*: any*/),
                                                                                                (v29 /*: any*/),
                                                                                                (v10 /*: any*/),
                                                                                                (v24 /*: any*/),
                                                                                                (v12 /*: any*/),
                                                                                                (v9 /*: any*/),
                                                                                                (v4 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v6 /*: any*/),
                                                                                                (v26 /*: any*/),
                                                                                                (v27 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v34 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v18 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v2 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                        },
                                                                        (v32 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                        },
                                        (v32 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                (v26 /*: any*/),
                                                (v27 /*: any*/)
                                            ]
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "77aeb5f12fef3865f0a855fbf19ea9a9",
            "metadata": {},
            "name": "CreateCommentReplyMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3675e2ca7da1d8f48bc9bff9fed2ec0e';
export default node;
